var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadToCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5382 7.15203C17.1438 4.26594 14.6914 2.08984 11.7578 2.08984C9.87055 2.08984 8.13434 2.97734 7.03148 4.48469C5.43816 4.18313 3.90859 5.23484 3.60684 6.81125C1.57496 7.07152 0 8.79648 0 10.8789C0 13.1405 1.83996 14.9805 4.10156 14.9805H8.24219V13.8086H4.10156C2.48613 13.8086 1.17188 12.4943 1.17188 10.8789C1.17188 9.26348 2.50363 7.94922 4.14062 7.94922H4.72656V7.36328C4.72656 6.39402 5.51512 5.60547 6.48438 5.60547C6.93699 5.60547 7.18445 5.76195 7.52836 5.87082L7.77922 5.46934C8.64285 4.08699 10.1302 3.26172 11.7578 3.26172C14.1875 3.26172 16.2303 5.17141 16.4083 7.6093L16.4365 7.99547L16.8029 8.12094C18.0142 8.53586 18.8281 9.64422 18.8281 10.8789C18.8281 12.4943 17.5139 13.8086 15.8984 13.8086H11.7578V14.9805H15.8984C18.16 14.9805 20 13.1405 20 10.8789C20 9.26848 19.0251 7.81445 17.5382 7.15203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9294 12.4656L12.758 11.637L9.99999 8.87891L7.24194 11.637L8.07054 12.4656L9.41405 11.1221V17.9107H10.5859V11.1221L11.9294 12.4656Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadToCloud);
export default __webpack_public_path__ + "static/media/upload_to_cloud.b12fceec1e9c2bd34d9c679094b5d362.svg";
export { ForwardRef as ReactComponent };